<div>
   <ng-template contentTemplateOutlet></ng-template>
</div>
